<template>
  <CartErrorModal />

  <Drawer
    v-if="cartStore.isOpen"
    position="right"
    class="max-w-[450px]!"
    :title="$t('My shopping cart')"
    @close="cartStore.closeCart()">
    <template #title="{ data }">
      <ShoppingCartIcon class="size-5" />
      {{ data.title }}
    </template>
    <div class="flex flex-col gap-6">
      <div v-if="cartStore.loading && !cartStore.items?.length" class="grid gap-2" data-testid="cart-loading-indicator">
        <div class="relative">
          <Skeleton variant="rounded" class="h-14 w-full rounded-xl" />
          <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div
              class="size-5 border-2 border-muted-foreground/70 border-t-muted-foreground/25 rounded-full animate-spin"></div>
          </div>
        </div>
        <span class="sr-only">{{ $t("Updating cart...") }}</span>
      </div>
      <template v-if="cartStore.items?.length">
        <CartReservation />
        <div class="h-[1px] bg-border"></div>
        <template v-if="cartStore.loading">
          <div class="relative">
            <Skeleton variant="rounded" class="h-56 w-full rounded-xl" />
            <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div
                class="size-6 border-2 border-muted-foreground/70 border-t-muted-foreground/25 rounded-full animate-spin"></div>
            </div>
          </div>
          <div class="relative">
            <Skeleton variant="rounded" class="h-64 w-full rounded-xl" />
            <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div
                class="size-6 border-2 border-muted-foreground/70 border-t-muted-foreground/25 rounded-full animate-spin"></div>
            </div>
          </div>
        </template>
        <template v-else>
          <CartItems />
          <ReservationTotals compact class="flex-none" />
        </template>
        <RouterLink
          to="/checkout"
          :class="!cartStore.timeLeft && 'pointer-events-none'"
          data-testid="continue-to-checkout"
          @click="cartStore.closeCart()">
          <Button :disabled="!cartStore.timeLeft" class="w-full gap-1 items-center h-12">
            {{ $t("Continue to checkout") }}
            <ChevronRightIcon class="size-4" />
          </Button>
        </RouterLink>
      </template>
      <Alert v-else-if="!cartStore.loading">
        <span>{{ $t("There are no items in your shopping cart right now...") }}</span>
      </Alert>
    </div>
  </Drawer>
</template>

<script setup>
import CartReservation from "@/components/cart/CartReservation.vue";
import CartItems from "@/components/cart/CartItems.vue";
import CartErrorModal from "@/components/cart/CartErrorModal.vue";
import ReservationTotals from "@/components/reservations/ReservationTotals.vue";

import { useCartStore } from "@/store/cart.ts";

import { RouterLink } from "vue-router";
import { ChevronRightIcon, ShoppingCartIcon } from "@heroicons/vue/24/outline";
import { Button, Drawer, Skeleton, Alert } from "@xs2event/js-lib/components";

const cartStore = useCartStore();
</script>
